import type { PropType } from 'vue'
import {
  defineComponent,
  watch,
} from 'vue'
import styles from './Toast.module.scss'

export default defineComponent({
  name: 'MkToast',
  props: {
    visible: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    tip: {
      type: String,
      default: '链接失效',
    },
  },
  setup(props, { slots, emit }) {
    // const show = ref(props.visible)

    watch(() => props.visible, (val) => {
      if (val) {
        let timer: any = setTimeout(() => {
          emit('update:visible', false)
          clearTimeout(timer)
          timer = null
        }, 2000)
      }
    })

    return () => (
      <div v-show={props.visible} class={styles['toast-wrapper']}>
        <div class={`${styles.toast} toast-value`}>
          {/* icon */}
          {slots.icon ? slots.icon() : <img class={styles.toast_icon_warning} src={require('./images/toast_icon_warning.png')} alt="toast_icon_warning"/>}
          {/* tip */}
          {slots.tip ? slots.tip() : <div class={styles.tip} v-html={props.tip}></div>}
        </div>
      </div>
    )
  },
})
